module.exports = __webpack_public_path__ + "static/media/wordmark-logo-black.84e47abd.png";